import findIndex from 'lodash/findIndex';
import remove from 'lodash/remove';
import {
  FETCH_INSTALLMENTS_SUCCESS,
  UPDATE_INSTALLMENT_SUCCESS,
  CREATE_INSTALLMENT_SUCCESS,
  DELETE_INSTALLMENT_SUCCESS,
  CLEAR_FINANCIALS,
} from '../../actions/action-types';

const initialState = [];

const installments = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_INSTALLMENTS_SUCCESS:
      return action.payload;
    case UPDATE_INSTALLMENT_SUCCESS: {
      const updatedIndex = findIndex(
        state,
        installment => installment.id === action.payload.id,
      );
      const stateCopy = [...state];
      stateCopy[updatedIndex] = action.payload;
      return stateCopy;
    }
    case CREATE_INSTALLMENT_SUCCESS: {
      const stateCopy = [...state];
      stateCopy.push(action.payload);
      return stateCopy;
    }
    case DELETE_INSTALLMENT_SUCCESS: {
      const stateCopy = [...state];
      remove(stateCopy, installment => installment.id === action.payload);
      return stateCopy;
    }
    case CLEAR_FINANCIALS: {
      return initialState;
    }
    default:
      return state;
  }
};

export default installments;
